import { ReactNode, useState } from "react";
import { Icons } from "assets";
import classNames from "classnames";
import styles from "./style.module.scss";

interface CustomAccordionProps {
  title: string;
  badgeTitle?: string;
  headerActions?: ReactNode;
  children: ReactNode;
  isOpen: boolean;
  onClick: () => void;
}

const CustomAccordion = ({
  title,
  badgeTitle,
  headerActions,
  children,
  isOpen,
  onClick,
}: CustomAccordionProps) => {
  return (
    <div
      className={classNames(styles.accordion, {
        [styles.active]: isOpen,
      })}
    >
      <div
        className={classNames(styles.accordionHeader, {
          [styles.active]: isOpen,
        })}
        onClick={onClick}
      >
        <div className={styles.headerInner}>
          <div className={classNames(styles.titleEnclosure, "flex")}>
            <h4>{title}</h4>
            {badgeTitle && (
              <div className={styles.badgeEnclosure}>
                <p className={styles.badgeTitleContainer}>{badgeTitle}</p>
              </div>
            )}
          </div>
          {headerActions && (
            <div
              className={styles.headerActions}
              onClick={(e) => e.stopPropagation()}
            >
              {headerActions}
            </div>
          )}
          <span
            className={classNames(styles.chevronIcon, {
              [styles.rotate]: isOpen,
            })}
          >
            <Icons.ChevDown />
          </span>
        </div>
      </div>

      {isOpen && (
        <div
          className={classNames(styles.accordionContent, {
            [styles.active]: isOpen,
          })}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default CustomAccordion;
interface AccordionItem {
  id: string;
  title: string;
  badgeTitle?: string;
  headerActions?: ReactNode;
  content: ReactNode;
}

interface CustomAccordionGroupProps {
  items: AccordionItem[];
  defaultOpenIndex?: number;
  showBadge?: boolean;
}

export const CustomAccordionGroup = ({
  items,
  defaultOpenIndex = 0,
  showBadge = true,
}: CustomAccordionGroupProps) => {
  const [openId, setOpenId] = useState<string | null>(
    items[defaultOpenIndex]?.id || null,
  );

  const handleToggle = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <>
      {items.map((item) => (
        <CustomAccordion
          key={item.id}
          title={item.title}
          badgeTitle={showBadge ? item.badgeTitle : undefined}
          headerActions={item.headerActions}
          isOpen={openId === item.id}
          onClick={() => handleToggle(item.id)}
        >
          {item.content}
        </CustomAccordion>
      ))}
    </>
  );
};
